module.exports = __webpack_public_path__ + "media/images/icon__delete--rb-orange@3x-2b85492966195f1ab5791a56a5e3f7f5.png";